// Get Environment

const ENV_CONFIG = {
  dev: {
    API_URL: process.env.REACT_APP_API_URL_DEV,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_DEV,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_DEV,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_DEV,
  },
  staging: {
    API_URL: process.env.REACT_APP_API_URL_STAGING,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_STAGING,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_STAGING,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_STAGING,
  },
  production: {
    API_URL: process.env.REACT_APP_API_URL_PROD,
    PAYMENT_URL: process.env.REACT_APP_API_PAYMENT_URL_PROD,
    PRODUCT: process.env.REACT_APP_PRODUCT,
    DESKTOP_VIEW: process.env.REACT_APP_DESKTOP_VIEW_PROD,
    PHP_API_BASE_URL: process.env.REACT_APP_PHP_URL_PROD,
  },
};

const getEnvironment = () => {
  const server = process.env.REACT_APP_SERVER;

  if (!server) {
    throw new Error("Environment variables is not defined!");
  }

  return ENV_CONFIG[server];
};

export { getEnvironment };
